import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import EtelAPI from '../api/EtelAPI';
import Alerts from '../prototypes/Alerts';
import Overlay from './Overlay';

import {

  MultiLevelGrid,
  MultiLevelGridHeader,
  MultiLevelGridHeaderColumn,
  MultiLevelGridBody,
  MultiLevelGridRow,
  MultiLevelGridRowLabelCell,

} from './MultiLevelGrid';

import {
  Dialog,
  DialogHeader,
  DialogBody,
} from './Dialog';


class LeadgenFileDialog extends React.Component{

  constructor( props ){
    super( props );
    this.state = {
      layout: this.props.layout === undefined ? {} : this.props.layout,
      show: this.props.show === undefined ? false : this.props.show,
      dialogtitle: this.props.dialogtitle === undefined ? '[No Title]' : this.props.dialogtitle,
      currentitem: this.props.currentitem === undefined ? {} : this.props.currentitem,
      insertDone: this.props.insertdone === undefined ? false : this.props.insertdone,
      updateDone: this.props.updateDone === undefined ? false : this.props.updateDone,
      uploadDone: false,
      renderData: false,
      uploadData: [],
      filecheck: this.props.filecheck === undefined ? false : this.props.filecheck,
      filecountsuccess: this.props.filecount === undefined ? 0 : this.props.filecount,
      filecountfailure: this.props.filecountfailure === undefined ? 0 : this.props.filecountfailure,
      fileuploadstatus: this.props.fileuploadstatus === undefined ? {'TOTAL_COUNT':0} : this.props.fileuploadstatus
    };
  }

  componentWillReceiveProps( nextProps ){
    let totalfiles = nextProps.filecountsuccess + nextProps.filecountfailure;
    if ( nextProps.currentitem !== undefined && nextProps.fileuploadstatus !== undefined ){
      if ( nextProps.fileuploadstatus['TOTAL_COUNT'] === totalfiles ){
        if ( totalfiles > 0 ){
          this.setState( {uploadDone: true} );
        }
      }
    }

    //For when the user clicks the "Show Uploaded Files" button
    if ( nextProps.filecheck !== undefined ){
      if ( nextProps.filecheck === true ){
        this.retrieveData();
      }
    }

    this.setState( {
      layout: nextProps.layout === undefined ? {} : nextProps.layout,
      show: nextProps.show,
      dialogtitle: nextProps.dialogtitle === undefined ? '[No Title]' : nextProps.dialogtitle,
      currentitem: nextProps.currentitem === undefined ? {} : nextProps.currentitem,
      insertDone: nextProps.insertdone === undefined ? false : nextProps.insertdone,
      updateDone: nextProps.updateDone === undefined ? false : nextProps.updateDone,
      filecheck: nextProps.filecheck === undefined ? false : nextProps.filecheck,
      filecountsuccess: nextProps.filecountsuccess === undefined ? 0 : nextProps.filecountsuccess,
      filecountfailure: nextProps.filecountfailure === undefined ? 0 : nextProps.filecountfailure,
      fileuploadstatus: nextProps.fileuploadstatus === undefined ? {'TOTAL_COUNT':0} : nextProps.fileuploadstatus
    } );

  }


  retrieveData( ) {
    const { dispatch } = this.props;
    const Bugsnag = this.props.bugsnag;
    let layout = this.state.layout;
    let endpoint = 'fileupload';
    let section = layout.section;
    let save = section.save === undefined ? '' : section.save;
    let currentitem = this.state.currentitem;

    if ( save === 'leadgen' ){
      if ( currentitem !== undefined ){
        let currentitem = this.state.currentitem;
        endpoint = '/' + endpoint + '/' + currentitem.LEADGEN_DEF_ID.toString();

        let api = new EtelAPI( endpoint );
        api.uri = endpoint;

        api.get( {} ).then( ( result ) =>{

          this.setState( {uploadData:result,renderData:true} );

        } ).catch( ( error ) =>{
          const alerts = new Alerts( Bugsnag, dispatch );
          alerts.CRITICAL( section.title, error.toString() );
        } );
      }
    }

  }



  renderGrid(){
    let data = this.state.uploadData;
    let row_count = 0;
    let headerrow = [];
    let tableheader = [];
    let gridrows = [];
    let cells = [];

    let file_new = 0;
    let file_fileuploaded = 1;
    let file_bulkinserted = 2;
    let file_imported = 3;
    let file_waiting = 4;
    let file_waitcleared = 5;
    let file_processed = 10;
    let file_lightning = 11;
    let file_deleting = 20;
    let file_error = 50;
    let file_duplicate = 100;
    let file_abort = 1000;


    let message = '';
    let table = '';

    let headers = {
      '':{'width':'50px','text':''}, //This will account for the expand icon
      'FILENAME':{'width':'17%','text':'FILENAME'},
      'UPLOAD_TYPE':{'width':'10%','text':'UPLOAD TYPE'},
      'STATUS_TEXT':{'width':'12%','text':'STATUS'},
      'COUNT_PROCESSED':{'width':'12%','text':'PROCESSED'},
      'COUNT_ERROR':{'width':'12%','text':'ERRORS'},
      'COUNT_DUPS':{'width':'12%','text':'DUPLICATES'},
      'COUNT_TOTAL':{'width':'8%','text':'TOTAL'},
      'CreateByUser':{'width':'12%','text':'USER'}
    };

    if ( data.length > 0 ){

      //Build the header for the table
      for( var col in headers ){
        let colElement = 'multi-level-grid-header-column-' + col.toLowerCase() + '-' + row_count.toString().toLowerCase();
        headerrow.push(
          <MultiLevelGridHeaderColumn key={colElement} text={headers[col].text} width={headers[col].width} />
        );
        row_count += 1;
      }

      //Build each row
      for( var j = 0; j < data.length; j++ ){
        row_count = 0;
        cells = [];
        let rowkey = 'multi-level-grid-row-' + j.toString();

        for ( col in headers ){
          if ( col === '' ){
            continue;
          }
          let cellkey = 'multi-level-grid-row-cell-' + col.toString() + row_count.toString();
          let text = data[j][col];
          cells.push(
            <MultiLevelGridRowLabelCell key={cellkey} text={text} width={headers[col].width} tooltip format={text} />
          );
          row_count += 1;
        }

        if( data[j].NUMBERS === undefined ){
          data[j].NUMBERS = [];
        }

        let datarow = data[j].NUMBERS;
        let status = data[j].STATUS;
        tableheader = [];

        //If there is data, but no numbers to show, display the appropriate message
        switch( status ){
        case file_new:
          message = 'This file has started processing';
          break;
        case file_fileuploaded:
          message = 'This file has started uploading';
          break;
        case file_bulkinserted:
          message = 'This file has just bulk inserted';
          break;
        case file_imported:
          message = 'The contents of this file were just imported to the appropriate destination';
          break;
        case file_waiting:
          message = 'This file is currently waiting for the next process';
          break;
        case file_waitcleared:
          message = 'This file has finished waiting';
          break;
        case file_processed:
          message = 'This file was processed successfully';
          break;
        case file_lightning:
          message = 'This file will be processed momentarily';
          break;
        case file_deleting:
          message = 'This file has started a deleting process';
          break;
        case file_error:
          message = 'An error occurred when attempting to process this file';
          break;
        case file_duplicate:
          message = 'Duplicate(s) were found in the file';
          break;
        case file_abort:
          message = 'This file was aborted under certain circumstances';
          break;
        default:
          message = 'Status regarding this file is unknown';
          break;
        }

        let childheaders = [
          {'column':'NUMBER','text':'NUMBER','width':'25%'},
          {'column':'NOTES','text':'NOTES','width':'75%'}
        ];

        if ( datarow.length > 0 ){
        //Build the header of the inner table
          for( var y = 0; y < childheaders.length; y++ ){
            let col = childheaders[y].column;
            let text = childheaders[y].text;
            let colElement = 'table-level-grid-header-column-' + col.toLowerCase() + '-' + j.toString().toLowerCase() + '-' + y.toString().toLowerCase();
            tableheader.push( <th className={'leadgen-dialog-child-table-header'} key={colElement}>{text}</th> );
          }
        }

        //Build the inner table for all the numbers of a respective file
        let children = datarow.map( ( item, index ) => {
          let childcells = [];
          for( var x = 0; x < childheaders.length; x++ ) {
            const column = childheaders[x].column;
            const width = childheaders[x].width;
            const value = item[column];
            const cellkey = 'child-cell-' + x.toString();
            childcells.push(
              <td className={'leadgen-dialog-child-table-cell'} key={cellkey} style={{'width': width}}>
                {value}
              </td>
            );
          }

          const rowkey = 'child-row-' + index.toString();
          return (
            <tr className={'leadgen-dialog-child-table-row'} key={rowkey}>
              {childcells}
            </tr>
          );
        } );

        table = ( <p style={{'marginLeft':'55px'}}>{message}</p> );

        if ( children.length > 0 ){
          table = (
            <table className={'leadgen-dialog-child-table'}>
              <thead>
                <tr>
                  {tableheader}
                </tr>
              </thead>
              <tbody>
                {children}
              </tbody>
            </table>
          );
        }

        gridrows.push(
          <MultiLevelGridRow rowkey={rowkey} key={rowkey} HasExpandPanel ExpandPanelChildren={table} >
            {cells}
          </MultiLevelGridRow>
        );

      }
    }

    if( data.length > 0 ){
      return (
        <span>
          <MultiLevelGrid>
            <MultiLevelGridHeader HasExpandPanel={true}>
              {headerrow}
            </MultiLevelGridHeader>
            <MultiLevelGridBody>
              {gridrows}
            </MultiLevelGridBody>
          </MultiLevelGrid>
        </span>
      );
    }else if( this.state.renderData === true ){
      return (
        <span>This group has no uploaded files</span>
      );
    }else{
      return(
        <span></span>
      );
    }

  }

  renderModal(){
    //Rendering information about insert/update
    let operation = false;
    let width = 60;
    let height = 54;
    let modal_body = '';
    if( this.state.updateDone === 'failed' || this.state.insertDone === 'failed' ){
      operation = 'failed';
    }else if( this.state.updateDone === true || this.state.insertDone === true ){
      operation = true;
    }

    let savestatus = operation === true ? 'Complete' : 'Incomplete';
    let vsavecheck = operation === true || operation === 'failed' ? 'visible' : 'hidden';


    //Rendering information about file
    let pass = this.state.filecountsuccess;
    let exptotal = this.state.fileuploadstatus['TOTAL_COUNT'];
    let progress = this.state.uploadDone === true ? true : false;
    let filestatus = progress && pass === exptotal ? 'Complete' : 'Incomplete';
    let vfilecheck = progress ? 'visible' : 'hidden';


    //Rendering messages
    let fileprogress = '(' + pass.toString() + '/' + exptotal.toString() + ')';
    let messageOne = 'Leadgen Saved - ' + savestatus;
    let messageTwo = 'Files Uploaded ' + fileprogress + ' - ' + filestatus;

    //CSS displays
    let stylesave = {'visibility':vsavecheck,'fontSize:':'19px','color': savestatus === 'Complete' ? 'green':'red'};
    let stylefile = {'visibility':vfilecheck,'fontSize:':'19px','color': filestatus === 'Complete' ? 'green':'red'};
    let classNameSave = savestatus === 'Complete' ? 'icon-fontello-ok-circle-2' : 'icon-fontello-cancel-circle-3';
    let classNameFile = filestatus === 'Complete' ? 'icon-fontello-ok-circle-2' : 'icon-fontello-cancel-circle-3';

    if( this.state.filecheck === true ){
      modal_body = (
        <div id='modal_body_tmp'>
          <div>
            <p>Note:</p>
            {'Only numbers that have an error or a duplicate will appear when you expand a file.'}<br/><br/>
          </div>
          {this.renderGrid()}
        </div>
      );


    } else {
      width = 40;
      height = 40;
      modal_body = (
        <div className={'leadgen-dialog-message'}>
          <div>
            <i style={stylesave} className={classNameSave} />&nbsp;&nbsp;&nbsp;&nbsp;
            {messageOne}
          </div>
          <div>
            <i style={stylefile} className={classNameFile} />&nbsp;&nbsp;&nbsp;&nbsp;
            {messageTwo}
          </div>
          <br/><br/>
          <p>{ pass > 0 ? 'You can check the progress for your uploaded numbers by clicking the "Show Uploaded Files" on the Edit form': '' }</p>
        </div>
      );
    }

    return (
      <div>
        <Overlay show={this.state.show} />
        <Dialog width={width} height={height} show={this.state.show} >
          <DialogHeader caption={this.state.dialogtitle} closeButton onClose={this.props.onCancel} />
          <DialogBody className={'dialog-body'}>
            {modal_body}
          </DialogBody>
        </Dialog>
      </div>
    );
  }


  render(){
    return (
      <div className='leadgen-dialog'>
        {this.renderModal()}
      </div>
    );
  }

}

export default withRouter(
  connect (
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( LeadgenFileDialog ) );



// WEBPACK FOOTER //
// ./src/presentation/LeadgenFileDialog.js